import PropTypes from 'prop-types';

import ImpactBadge from "components/ImpactBadge";
import Badge from 'components/Badge';

import PresenceBadge from "./PresenceBadge";
import ChevronIcon from './ChevronIcon';

FoldableHeader.propTypes = {
    title: PropTypes.string.isRequired,
    impact: PropTypes.number,
    source: PropTypes.string,
    status: PropTypes.bool,
    open: PropTypes.bool,
    onClick: PropTypes.func,
};

function FoldableHeader({
    title = '',
    impact = 0,
    source = null,
    status = false,
    open = false,
    onClick = () => {}
}) {
    return (
        <div
            onClick={onClick}
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "16px 20px",
                cursor: "pointer",
                userSelect: "none",
                backgroundColor: "#ffffff",
                borderRadius: open ? "12px 12px 0 0" : "12px",
            }}
            onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#fafafa")}
            onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#ffffff")}
        >
            <div style={{display: "flex", alignItems: "center", gap: "12px"}}>
                <ChevronIcon open={open} />
                <span style={{fontWeight: "700", fontSize: "15px", color: "#111827"}}>
                    {title}
                </span>
                <ImpactBadge level={impact} />
                <Badge rounded>{source}</Badge>
            </div>
            <PresenceBadge status={status} />
        </div>
    );
}


export default FoldableHeader;
